"use client";

import dynamic from "next/dynamic";

const GuestChatPage = dynamic(
  () => import("@/components/custom/chat-guest/GuestChatPage"),
);
const UserChatPage = dynamic(
  () => import("@/components/custom/chat/UserChatPage"),
);

export default function ChatRouteClient({ isLogin }: { isLogin: boolean }) {
  if (isLogin) {
    return <UserChatPage />;
  }

  return <GuestChatPage />;
}
